import styled from "styled-components";

export const ProfileVolunteerSpotlight = styled.div`
  width: 100%;
  height: 100%;
  max-height: 37.5rem;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 1.25rem;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  border: 1px solid #ececec;
  position: relative;
  z-index: 2;
  padding: 1.5rem 1rem 1rem 1rem;
  @media (max-width: 48rem) {
    height: auto;
  }
  &.collapsed {
    height: 28.125rem;
  }

  &.expanded {
    height: auto;
    overflow-y: hidden;
  }
`;

export const ProfileVolunteerHeader = styled.div`
  padding-top: 1.25rem;
  margin-left: 0.9375rem;
  padding-right: 0.3125rem;
  padding-bottom: 1.5625rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  h2 {
    color: #000000;
    font-size: 1.125rem;
    font-weight: bold;
    line-height: 1.05875rem;
    text-align: left;
  }

  .view-more {
    color: #fe2f67;
    font-size: 0.875rem;
    font-weight: bold;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 0.3125rem;
  }

  .view-more:hover {
    text-decoration: none;
  }
`;

export const ProfileVolunteersContainer = styled.div`
  max-width: 100%;
  height: 14.21625rem;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: hidden;
  scroll-behavior: smooth;
  background: #ffffff;
  padding-top: 1.875rem;
  padding-left: 0.9375rem;
  padding-right: 0.9375rem;
  align-items: center;
  transition: height 0.3s ease;

  &.collapsed {
    overflow-y: hidden;
    height: 25rem;
  }

  &.expanded {
    height: 25rem;
    max-height: 25rem;
    overflow-y: auto;
    /* Scrollbar styles */
    scrollbar-width: thin;
    scrollbar-color: #fe2f67 #f0f0f0;
  }

  &.expanded::-webkit-scrollbar {
    width: 0.5rem;
    background: #f0f0f0;
    border-radius: 0.5rem;
  }
  &.expanded::-webkit-scrollbar-thumb {
    background: #fe2f67;
    border-radius: 0.5rem;
  }
  &.expanded::-webkit-scrollbar-thumb:hover {
    background: #d81b60;
  }
`;

export const ProfileVolunteerContainer = styled.div`
  width: 90%;
  margin: 0 auto 1.25rem auto;
  height: 3.103125rem;
  display: flex;
  flex-direction: row;
  background: #fafbfc;
  border-radius: 0.75rem;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  position: relative;
  padding: 0.5rem ;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 0 0 4px rgba(254, 47, 103, 0.15), 0 2px 12px rgba(0,0,0,0.08);
    border: 1px solid #fe2f67;
  }
`;

export const ProfileVolunteerImage = styled.img`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  object-fit: cover;
  margin-left: 0;
  padding-left: 0;
  position: relative;
  z-index: 1;
`;

export const NotificationCircle = styled.div`
  width: 1.125rem;
  height: 1.125rem;
  background-color: #fe2f67;
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: bold;
  position: absolute;
  top: 0.15rem;
  left: 0.15rem;
  z-index: 2;
`;

export const ProfileVolunteerInfo = styled.div`
  padding-left: 0.625rem;
  margin-right: 0.625rem;
`;

export const ProfileVolunteerName = styled.p`
  width: 9.375rem;
  height: 1.375rem;
  color: #000000;
  font-size: 1.154375rem;
  line-height: 1.3975rem;
  text-align: left;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(to right, black 90%, transparent 100%);
  mask-image: linear-gradient(to right, black 90%, transparent 100%);
`;

export const ProfileVolunteerDetail = styled.p`
  width: 9.375rem;
  font-size: 0.625rem;
  color: #000000;
  margin-bottom: 0.625rem;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: 3em;
  min-height: 3em;
  white-space: pre-line;
`;

export const ProfileVolunteerSpotlightIcons = styled.div`
  width: 4.690625rem;
  height: 1.0825rem;
  display: flex;
  gap: 0.721875rem;
  align-items: center;
  padding-top: 0.9375rem;
  padding-left: 0.3125rem;
  .MuiSvgIcon-root {
    font-size: 1.25rem;
  }
`;